








































import {Component, Vue, Prop} from 'vue-property-decorator';
import {Action} from 'vuex-class';

@Component
export default class DlgSubscriptionsDelete extends Vue {
  @Prop({type: Object, default: {}}) private subscription!: any;

  private loading: boolean = false;
  private dialog: boolean = false;

  @Action('admin/subscriptions/del') private storeDeleteSubscription!: (subscription: any) => Promise<boolean>;
  @Action('admin/users/readOne') private readUser!: (id: string) => Promise<boolean>;

  private deleteSubscription() {
    this.loading = true;
    this.storeDeleteSubscription({id: this.subscription.id})
      .then((success) => {
        if (!success) {
          throw new Error('Error while creating subscription');
        }
        return this.$emit('done');
      })
      .then(() => {
        this.loading = false;
        this.dialog = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }
}
